import { fetchManufacturerList } from '#/api/imsMgmt/settings/manufacturer/fetchList';

export {
  ENTITY_STATUS_FILTER_OPTIONS as MTR_STATUS_FILTER_OPTIONS,
  formatEntityStatusLabel as formatMtrStatusLabel,
} from '#/modules/commonComponents/table/entityStatus';

export const MTR_KIND_FILTER_OPTIONS = [
  { value: 'NORMAL', label: '一般物料' },
  { value: 'GROUP', label: '替代物料' },
];

export function formatMtrKindLabel(kind) {
  if (kind == null || kind === '') {
    return '—';
  }
  const match = MTR_KIND_FILTER_OPTIONS.find((option) => option.value === kind);
  return match?.label ?? String(kind);
}

/** DRAFT／INACTIVE → 可 activate。 */
export function canActivateMtr(status) {
  return status === 'DRAFT' || status === 'INACTIVE';
}

/** ACTIVE → 可 deactivate。 */
export function canDeactivateMtr(status) {
  return status === 'ACTIVE';
}

export async function searchManufacturerFilterOptions({ keyword }) {
  const result = await fetchManufacturerList({
    page: 1,
    pageSize: 20,
    keyword: keyword ?? '',
    filters: {},
    sort: [],
  });

  return (result.data ?? []).map((item) => ({
    value: item.id,
    label: item.code ? `${item.code} - ${item.name}` : item.name,
  }));
}

export function formatOriginalSerialList(value) {
  if (!Array.isArray(value) || value.length === 0) {
    return '-';
  }

  return value.join(', ');
}
